var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-checkbox-group',_vm._g(_vm._b({attrs:{"value":_vm.value},on:{"change":(val) => _vm.$emit('input', val)}},'el-checkbox-group',_vm.$attrs,false),_vm.$listeners),_vm._l((_vm.options),function({text, ...attrs}){return _c('el-checkbox',_vm._b({key:attrs.label},'el-checkbox',attrs,false),[_vm._v("\n        "+_vm._s(text)+"\n    ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }